import { cn } from "@/lib/cn";

/**
 * Standardized section/page header with eyebrow, title, and lede.
 * Establishes a consistent rhythm across every section.
 */
export const SectionHeader = ({
  eyebrow,
  number,
  title,
  description,
  align = "left",
  className,
  actions,
  testId,
}) => {
  return (
    <header
      data-testid={testId || "section-header"}
      className={cn(
        "flex flex-col gap-5",
        align === "center" && "items-center text-center",
        className
      )}
    >
      {(eyebrow || number) && (
        <div className="flex items-center gap-3">
          {number && (
            <span className="font-mono text-[11px] tabular-nums text-muted-foreground">
              {number}
            </span>
          )}
          {number && eyebrow && (
            <span className="h-px w-6 bg-border" aria-hidden="true" />
          )}
          {eyebrow && <span className="haevn-eyebrow">{eyebrow}</span>}
        </div>
      )}
      <div className={cn("flex flex-col gap-4", align === "center" && "items-center")}>
        <h1
          className={cn(
            "max-w-3xl text-3xl font-medium tracking-tightest text-foreground sm:text-4xl md:text-5xl",
            "leading-[1.05]"
          )}
        >
          {title}
        </h1>
        {description && (
          <p className="max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2 pt-2">{actions}</div>}
    </header>
  );
};

export default SectionHeader;
